import { useState } from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [ sidebarOpen, setSidebarOpen ] = useState(true);
  const pathname = window.location.pathname;

  const blacklistedPaths = [
    '/dashboard/',
    '/search',
    '/login',
    '/patient_login',
    '/organizations',
    '/patient_dashboard',
    '/error',
    '/verify-invite',
    '/setup-account',
    '/zoom/in-client/redirect',
  ];

  const shouldShowSidebar = () => {
    return !blacklistedPaths.some(path => pathname.includes(path)) && pathname !== '/';
  };

  const toggleSidebar = () => { setSidebarOpen(!sidebarOpen); };

  const showSidebar = shouldShowSidebar();

  return (
    <div className="min-h-screen">
      {showSidebar && <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />}
      <main className={`transition-all duration-300 ${showSidebar ? (sidebarOpen ? 'ml-16 md:ml-64' : 'ml-16') : 'ml-0'}`}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
